<div class="main-stream-header">
  <h3 [ngClass]="getTitleIcon(stream)">{{ getTitle(stream) | translate }}</h3>
</div>
<div #visioMainStreamContainer class="main-stream-content">
  <cng-visio-toggle-actions *ngIf="!!stream && stream?.videoType != 'screen'" [stream]="stream"></cng-visio-toggle-actions>
</div>
